import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { routes } from '@fly/shared';
import { BreadcrumbComponent } from '@fly/shared-ui';
import { Link as RadixLink } from '@radix-ui/themes';

export const BaseBreadcrumb: BreadcrumbComponent = ({
  isLast,
}: ComponentProps<BreadcrumbComponent>) => {
  const { t } = useTranslation();

  const to: string = routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ROOT;
  const title = t('app.dashboard.runtime_environments.title', {
    defaultValue: 'Runtime Environments',
  });

  return isLast ? (
    <RadixLink className='text-fly-general-black'>
      <strong>{title}</strong>
    </RadixLink>
  ) : (
    <RadixLink asChild color='gray'>
      <Link className='font-semibold' to={to}>
        {title}
      </Link>
    </RadixLink>
  );
};
